import { isBoolean } from 'lodash';
import { Translate, useTranslate } from 'react-admin';
import { HistoryUpdatedField } from '../config/types/history';
import { historyTranslateFields } from '../constants/history';

// A 'bool' history field's before/after value is `true`/`false`/`null` (never
// set yet). Without this, raw interpolation of `null` into a translation
// string (e.g. "%{before} -> %{after}") renders as "null" or an empty string
// instead of a readable "Aucun".
export const getBooleanLabel = (value: unknown, t: Translate): string =>
  isBoolean(value)
    ? t(`field.boolean.${value ? 'yes' : 'no'}`)
    : t('field.boolean.none');

// translations arg before, after
export const translationField = (
  itemValue: string,
  translation_key: HistoryUpdatedField | string
) => {
  const t = useTranslate();

  if (
    translation_key === 'history.contractmilestone.field_updated.discount' ||
    translation_key ===
      'history.contractmilestone.field_updated.professional_indemnity_percentage' ||
    translation_key === 'history.contractmilestone.field_updated.vat'
  ) {
    const numericValue = parseFloat(itemValue);
    if (!isNaN(numericValue) && itemValue !== null && itemValue !== undefined) {
      let value = numericValue;
      if (Math.abs(numericValue) < 1) {
        value = numericValue * 100;
      }

      itemValue = (Math.round(value * 100) / 100).toString();
    }
  }

  const translate_label =
    historyTranslateFields[translation_key] !== undefined &&
    historyTranslateFields[translation_key].translation_prefix
      ? t(
          `${
            historyTranslateFields[translation_key].translation_prefix
          }.${itemValue}${
            historyTranslateFields[translation_key].translation_suffix
              ? `.${historyTranslateFields[translation_key].translation_suffix}`
              : ''
          }`
        )
      : itemValue;

  return translate_label;
};
